module.exports = __webpack_public_path__ + "static/media/vanamali.0b473bfd.png";